export const SKILLS = [
    { id: "python", label: "Python" },
    { id: "java", label: "Java" },
    { id: "javascript", label: "JavaScript" },
    { id: "c", label: "C" },
    { id: "c-plus-plus", label: "C++" },
    { id: "c-sharp", label: "C#" },
    { id: "ruby", label: "Ruby" },
    { id: "php", label: "PHP" },
    { id: "swift", label: "Swift" },
    { id: "kotlin", label: "Kotlin" },
    { id: "go", label: "Go" },
    { id: "rust", label: "Rust" },
    { id: "typescript", label: "TypeScript" },
    { id: "scala", label: "Scala" },
    { id: "perl", label: "Perl" },
    { id: "r", label: "R" },
    { id: "lua", label: "Lua" },
    { id: "haskell", label: "Haskell" },
    { id: "dart", label: "Dart" },
    { id: "objective-c", label: "Objective-C" },
    { id: "shell-scripting", label: "Shell scripting" },
    { id: "elixir", label: "Elixir" },
    { id: "crystal", label: "Crystal" },
    { id: "fsharp", label: "F#" },
    { id: "groovy", label: "Groovy" },
    { id: "clojure", label: "Clojure" },
    { id: "react", label: "React" },
    { id: "vue", label: "Vue.js" },
    { id: "angular", label: "Angular" },
    { id: "svelte", label: "Svelte" },
    { id: "ember", label: "Ember.js" },
    { id: "express", label: "Express.js" },
    { id: "django", label: "Django" },
    { id: "flask", label: "Flask" },
    { id: "spring", label: "Spring" },
    { id: "rails", label: "Ruby on Rails" },
    { id: "aspnet", label: "ASP.NET" },
    { id: "laravel", label: "Laravel" },
    { id: "nextjs", label: "Next.js" },
    { id: "gatsby", label: "Gatsby" },
    { id: "nuxtjs", label: "Nuxt.js" },
    { id: "fastapi", label: "FastAPI" },
    { id: "blitzjs", label: "Blitz.js" },
    { id: "meteorjs", label: "Meteor.js" },
    { id: "backbonejs", label: "Backbone.js" },
    { id: "polymer", label: "Polymer" },
    { id: "preact", label: "Preact" },
    { id: "aurelia", label: "Aurelia" },
    { id: "nestjs", label: "NestJS" },
    { id: "jasmine", label: "Jasmine" },
    { id: "react-native", label: "React Native" },
    { id: "flutter", label: "Flutter" },
    { id: "xamarin", label: "Xamarin" },
    { id: "ionic", label: "Ionic" },
    { id: "cordova", label: "Cordova" },
    { id: "phonegap", label: "PhoneGap" },
    { id: "kivy", label: "Kivy" },
    { id: "nativescript", label: "NativeScript" },
    { id: "swiftui", label: "SwiftUI" },
    { id: "jetpack-compose", label: "Jetpack Compose" },
    { id: "mysql", label: "MySQL" },
    { id: "postgresql", label: "PostgreSQL" },
    { id: "mongodb", label: "MongoDB" },
    { id: "sqlite", label: "SQLite" },
    { id: "oracle", label: "Oracle Database" },
    { id: "sqlserver", label: "SQL Server" },
    { id: "cassandra", label: "Cassandra" },
    { id: "redis", label: "Redis" },
    { id: "firebase", label: "Firebase" },
    { id: "elasticsearch", label: "Elasticsearch" },
    { id: "dynamodb", label: "DynamoDB" },
    { id: "cockroachdb", label: "CockroachDB" },
    { id: "mariadb", label: "MariaDB" },
    { id: "realm", label: "Realm" },
    { id: "rethinkdb", label: "RethinkDB" },
    { id: "influxdb", label: "InfluxDB" },
    { id: "orientdb", label: "OrientDB" },
    { id: "arangodb", label: "ArangoDB" },
    { id: "couchbase", label: "Couchbase" },
    { id: "aws", label: "AWS" },
    { id: "gcp", label: "Google Cloud Platform" },
    { id: "azure", label: "Azure" },
    { id: "heroku", label: "Heroku" },
    { id: "ibm-cloud", label: "IBM Cloud" },
    { id: "alibaba-cloud", label: "Alibaba Cloud" },
    { id: "digitalocean", label: "DigitalOcean" },
    { id: "oracle-cloud", label: "Oracle Cloud" },
    { id: "netlify", label: "Netlify" },
    { id: "vercel", label: "Vercel" },
    { id: "docker", label: "Docker" },
    { id: "kubernetes", label: "Kubernetes" },
    { id: "podman", label: "Podman" },
    { id: "openvz", label: "OpenVZ" },
    { id: "virtualbox", label: "VirtualBox" },
    { id: "vmware", label: "VMware" },
    { id: "qemu", label: "QEMU" },
    { id: "hyper-v", label: "Hyper-V" },
    { id: "docker-compose", label: "Docker Compose" },
    { id: "lxc", label: "LXC" },
    { id: "rkt", label: "rkt" },
    { id: "singularity", label: "Singularity" },
    { id: "k8s", label: "K8S" },
    { id: "jenkins", label: "Jenkins" },
    { id: "gitlab-ci", label: "GitLab CI" },
    { id: "circleci", label: "CircleCI" },
    { id: "travis-ci", label: "Travis CI" },
    { id: "bamboo", label: "Bamboo" },
    { id: "teamcity", label: "TeamCity" },
    { id: "github-actions", label: "GitHub Actions" },
    { id: "argocd", label: "ArgoCD" },
    { id: "drone", label: "Drone" },
    { id: "concourse", label: "Concourse" },
    { id: "buildkite", label: "Buildkite" },
    { id: "spinnaker", label: "Spinnaker" },
    { id: "ansible", label: "Ansible" },
    { id: "puppet", label: "Puppet" },
    { id: "chef", label: "Chef" },
    { id: "saltstack", label: "SaltStack" },
    { id: "terraform", label: "Terraform" },
    { id: "packer", label: "Packer" },
    { id: "eas", label: "EAS" },
    { id: "git", label: "Git" },
    { id: "github", label: "GitHub" },
    { id: "gitlab", label: "GitLab" },
    { id: "bitbucket", label: "Bitbucket" },
    { id: "svn", label: "Subversion (SVN)" },
    { id: "mercurial", label: "Mercurial" },
    { id: "perforce", label: "Perforce" },
    { id: "bazaar", label: "Bazaar" },
    { id: "rest", label: "REST" },
    { id: "graphql", label: "GraphQL" },
    { id: "grpc", label: "gRPC" },
    { id: "soap", label: "SOAP" },
    { id: "websockets", label: "WebSockets" },
    { id: "json-rpc", label: "JSON-RPC" },
    { id: "xml-rpc", label: "XML-RPC" },
    { id: "protobuf", label: "Protocol Buffers" },
    { id: "openapi", label: "OpenAPI (Swagger)" },
    { id: "falcor", label: "Falcor" },
    { id: "nginx", label: "Nginx" },
    { id: "apache", label: "Apache HTTP Server" },
    { id: "tomcat", label: "Tomcat" },
    { id: "nodejs", label: "Node.js" },
    { id: "lighttpd", label: "Lighttpd" },
    { id: "caddy", label: "Caddy" },
    { id: "haproxy", label: "HAProxy" },
    { id: "iis", label: "Microsoft IIS" },
    { id: "uwsgi", label: "uWSGI" },
    { id: "gunicorn", label: "Gunicorn" },
    { id: "linux", label: "Linux" },
    { id: "windows", label: "Windows" },
    { id: "macos", label: "macOS" },
    { id: "freebsd", label: "FreeBSD" },
    { id: "ubuntu", label: "Ubuntu" },
    { id: "debian", label: "Debian" },
    { id: "redhat", label: "RedHat" },
    { id: "centos", label: "CentOS" },
    { id: "fedora", label: "Fedora" },
    { id: "arch", label: "Arch Linux" },
    { id: "android", label: "Android" },
    { id: "ios", label: "iOS" },
    { id: "raspberry-pi-os", label: "Raspberry Pi OS" },
    { id: "docker-os", label: "Docker OS" },
    { id: "openbsd", label: "OpenBSD" },
    { id: "manjaro", label: "Manjaro" },
    { id: "chrome-os", label: "Chrome OS" },
    { id: "alpine", label: "Alpine Linux" },
    { id: "oauth", label: "OAuth" },
    { id: "jwt", label: "JWT" },
    { id: "ldap", label: "LDAP" },
    { id: "openssl", label: "OpenSSL" },
    { id: "kerberos", label: "Kerberos" },
    { id: "ssl-tls", label: "SSL/TLS" },
    { id: "saml", label: "SAML" },
    { id: "vpn", label: "VPN" },
    { id: "firewall", label: "Firewall" },
    { id: "mfa", label: "MFA" },
    { id: "2fa", label: "2FA" },
    { id: "owasp", label: "OWASP" },
    { id: "hashing", label: "Hashing algorithms (SHA, MD5, bcrypt, etc.)" },
    { id: "encryption", label: "Encryption (AES, RSA)" },
    { id: "wpa3", label: "WPA3" },
    { id: "pki", label: "PKI" },
    { id: "smime", label: "S/MIME" },
    { id: "pgp", label: "PGP" },
    { id: "fido2", label: "FIDO2" },
    { id: "siem", label: "SIEM" },
    { id: "tensorflow", label: "TensorFlow" },
    { id: "pytorch", label: "PyTorch" },
    { id: "keras", label: "Keras" },
    { id: "scikit-learn", label: "Scikit-learn" },
    { id: "opencv", label: "OpenCV" },
    { id: "huggingface", label: "Hugging Face Transformers" },
    { id: "xgboost", label: "XGBoost" },
    { id: "fastai", label: "Fast.ai" },
    { id: "mahout", label: "Apache Mahout" },
    { id: "caffe", label: "Caffe" },
    { id: "theano", label: "Theano" },
    { id: "lightgbm", label: "LightGBM" },
    { id: "mxnet", label: "MXNet" },
    { id: "dl4j", label: "DL4J" },
    { id: "cntk", label: "Microsoft Cognitive Toolkit" },
    { id: "caffe2", label: "Caffe2" },
    { id: "torch", label: "Torch" },
    { id: "onnx", label: "ONNX" },
    { id: "mindspore", label: "MindSpore" },
    { id: "jax", label: "JAX" },
    { id: "chainer", label: "Chainer" },
    { id: "deepspeed", label: "DeepSpeed" },
    { id: "google-ai", label: "Google AI" },
    { id: "sagemaker", label: "AWS SageMaker" },
    { id: "azure-ml", label: "Azure" },
    { id: "watson", label: "IBM Watson" },
    { id: "clarifai", label: "Clarifai" },
    { id: "openai", label: "OpenAI" },
    { id: "datarobot", label: "DataRobot" },
    { id: "aws-comprehend", label: "AWS Comprehend" },
    { id: "azure-cognitive", label: "Azure Cognitive Services" },
    { id: "google-ai-platform", label: "Google AI Platform" },
    { id: "kubeflow", label: "Kubeflow" },
    { id: "mlflow", label: "MLflow" },
    { id: "pandas", label: "Pandas" },
    { id: "numpy", label: "NumPy" },
    { id: "scipy", label: "SciPy" },
    { id: "matplotlib", label: "Matplotlib" },
    { id: "seaborn", label: "Seaborn" },
    { id: "plotly", label: "Plotly" },
    { id: "jupyter", label: "Jupyter Notebooks" },
    { id: "rstudio", label: "RStudio" },
    { id: "spark", label: "Apache Spark" },
    { id: "d3", label: "D3.js" },
    { id: "tableau", label: "Tableau" },
    { id: "powerbi", label: "Power BI" },
    { id: "excel", label: "Excel" },
    { id: "flink", label: "Apache Flink" },
    { id: "knime", label: "KNIME" },
    { id: "orange", label: "Orange" },
    { id: "rapidminer", label: "RapidMiner" },
    { id: "alteryx", label: "Alteryx" },
    { id: "bokeh", label: "Bokeh" },
    { id: "altair", label: "Altair" },
    { id: "hadoop", label: "Hadoop" },
    { id: "kafka", label: "Apache Kafka" },
    { id: "flume", label: "Apache Flume" },
    { id: "storm", label: "Apache Storm" },
    { id: "hive", label: "Apache Hive" },
    { id: "hbase", label: "Apache HBase" },
    { id: "cassandra-db", label: "Apache Cassandra" },
    { id: "nifi", label: "Apache NiFi" },
    { id: "spark-streaming", label: "Spark Streaming" },
    { id: "presto", label: "Presto" },
    { id: "elasticsearch-db", label: "ElasticSearch" },
    { id: "kinesis", label: "Kinesis" },
    { id: "bigquery", label: "Google BigQuery" },
    { id: "vertica", label: "Vertica" },
    { id: "exasol", label: "Exasol" },
    { id: "greenplum", label: "Greenplum" },
    { id: "teradata", label: "Teradata" },
    { id: "airflow", label: "Apache Airflow" },
    { id: "snowflake", label: "SnowFlake" },
    { id: "ethereum", label: "Ethereum" },
    { id: "bitcoin", label: "Bitcoin" },
    { id: "solidity", label: "Solidity" },
    { id: "hyperledger", label: "Hyperledger" },
    { id: "ripple", label: "Ripple" },
    { id: "polkadot", label: "Polkadot" },
    { id: "chainlink", label: "Chainlink" },
    { id: "truffle", label: "Truffle" },
    { id: "web3js", label: "Web3.js" },
    { id: "ipfs", label: "IPFS" },
    { id: "eosio", label: "EOSIO" },
    { id: "cosmos", label: "Cosmos" },
    { id: "tezos", label: "Tezos" },
    { id: "cardano", label: "Cardano" },
    { id: "nfts", label: "NFTs" },
    { id: "defi", label: "Decentralized Finance (DeFi)" },
    { id: "smart-contracts", label: "Smart Contracts" },
    { id: "solana", label: "Solana" },
    { id: "bsc", label: "Binance Smart Chain" },
    { id: "algorand", label: "Algorand" },
    { id: "junit", label: "JUnit" },
    { id: "mocha", label: "Mocha" },
    { id: "selenium", label: "Selenium" },
    { id: "cypress", label: "Cypress" },
    { id: "jest", label: "Jest" },
    { id: "testng", label: "TestNG" },
    { id: "pytest", label: "PyTest" },
    { id: "chai", label: "Chai" },
    { id: "karma", label: "Karma" },
    { id: "puppeteer", label: "Puppeteer" },
    { id: "postman", label: "Postman" },
    { id: "cucumber", label: "Cucumber" },
    { id: "robot-framework", label: "Robot Framework" },
    { id: "junit5", label: "JUnit5" },
    { id: "appium", label: "Appium" },
    { id: "mockito", label: "Mockito" },
    { id: "nunit", label: "NUnit" },
    { id: "soapui", label: "SoapUI" },
    { id: "testcafe", label: "TestCafe" },
    { id: "ranorex", label: "Ranorex" },
    { id: "webpack", label: "Webpack" },
    { id: "parcel", label: "Parcel" },
    { id: "rollup", label: "Rollup" },
    { id: "vite", label: "Vite" },
    { id: "gulp", label: "Gulp" },
    { id: "grunt", label: "Grunt" },
    { id: "babel", label: "Babel" },
    { id: "eslint", label: "ESLint" },
    { id: "prettier", label: "Prettier" },
    { id: "postcss", label: "PostCSS" },
    { id: "esbuild", label: "Esbuild" },
    { id: "figma", label: "Figma" },
    { id: "sketch", label: "Sketch" },
    { id: "adobe-xd", label: "Adobe XD" },
    { id: "invision", label: "InVision" },
    { id: "zeplin", label: "Zeplin" },
    { id: "axure", label: "Axure RP" },
    { id: "balsamiq", label: "Balsamiq" },
    { id: "framer", label: "Framer" },
    { id: "marvel", label: "Marvel" },
    { id: "proto-io", label: "Proto.io" },
    { id: "google-analytics", label: "Google Analytics" },
    { id: "mixpanel", label: "Mixpanel" },
    { id: "hotjar", label: "Hotjar" },
    { id: "amplitude", label: "Amplitude" },
    { id: "heap", label: "Heap Analytics" },
    { id: "new-relic", label: "New Relic" },
    { id: "grafana", label: "Grafana" },
    { id: "prometheus", label: "Prometheus" },
    { id: "sentry", label: "Sentry" },
    { id: "datadog", label: "Datadog" },
    { id: "loggly", label: "Loggly" },
    { id: "splunk", label: "Splunk" },
    { id: "papertrail", label: "Papertrail" },
    { id: "fluentd", label: "Fluentd" },
    { id: "adobe-analytics", label: "Adobe Analytics" },
    { id: "zabbix", label: "Zabbix" },
    { id: "nagios", label: "Nagios" },
    { id: "unity", label: "Unity" },
    { id: "unreal", label: "Unreal Engine" },
    { id: "vuforia", label: "Vuforia" },
    { id: "arkit", label: "ARKit" },
    { id: "arcore", label: "ARCore" },
    { id: "webxr", label: "WebXR" },
    { id: "mixed-reality", label: "Mixed Reality" },
    { id: "hololens", label: "Microsoft HoloLens" },
    { id: "unity3d", label: "Unity3D" },
    { id: "godot", label: "Godot" },
    { id: "cocos2d", label: "Cocos2d" },
    { id: "cryengine", label: "CryEngine" },
    { id: "libgdx", label: "LibGDX" },
    { id: "pico8", label: "PICO-8" },
    { id: "construct", label: "Construct" },
    { id: "gamemaker", label: "GameMaker" },
    { id: "gamemaker-studio", label: "GameMaker Studio" },
    { id: "construct3", label: "Construct 3" },
    { id: "wordpress", label: "WordPress" },
    { id: "joomla", label: "Joomla" },
    { id: "drupal", label: "Drupal" },
    { id: "magento", label: "Magento" },
    { id: "wix", label: "Wix" },
    { id: "squarespace", label: "Squarespace" },
    { id: "shopify", label: "Shopify" },
    { id: "contentful", label: "Contentful" },
    { id: "strapi", label: "Strapi" },
    { id: "typo3", label: "TYPO3" },
    { id: "sitecore", label: "Sitecore" },
    { id: "woocommerce", label: "WooCommerce" },
    { id: "bigcommerce", label: "BigCommerce" },
    { id: "prestashop", label: "PrestaShop" },
    { id: "opencart", label: "OpenCart" },
    { id: "salesforce-commerce", label: "Salesforce Commerce Cloud" },
    { id: "http", label: "HTTP" },
    { id: "tcp-ip", label: "TCP/IP" },
    { id: "udp", label: "UDP" },
    { id: "dns", label: "DNS" },
    { id: "ftp", label: "FTP" },
    { id: "smtp", label: "SMTP" },
    { id: "pop3", label: "POP3" },
    { id: "imap", label: "IMAP" },
    { id: "ssh", label: "SSH" },
    { id: "sdn", label: "SDN" },
    { id: "blockchain", label: "Blockchain" },
    { id: "edge-computing", label: "Edge Computing" },
    { id: "serverless", label: "Serverless" },
    { id: "quantum-computing", label: "Quantum Computing" },
    { id: "iot", label: "IoT (Internet of Things)" },
    { id: "5g", label: "5G" },
    { id: "ar", label: "Augmented Reality (AR)" },
    { id: "vr", label: "Virtual Reality (VR)" },
    { id: "computer-vision", label: "Computer Vision" },
    { id: "nlp", label: "Natural Language Processing (NLP)" },
    { id: "edge-ai", label: "Edge AI" },
    { id: "federated-learning", label: "Federated Learning" },
    { id: "autonomous-systems", label: "Autonomous Systems" },
    { id: "rpa", label: "Robotic Process Automation (RPA)" },
    { id: "big-data", label: "Big Data Analytics" },
    { id: "no-code", label: "No-code" },
    { id: "low-code", label: "Low-code" },
    { id: "webassembly", label: "WebAssembly" },
    { id: "saas", label: "SaaS" },
    { id: "paas", label: "PaaS" },
    { id: "faas", label: "FaaS" },
    { id: "cdn", label: "CDN technologies" },
    { id: "load-balancers", label: "Load Balancers" },
    { id: "kong", label: "Kong" },
    { id: "apigee", label: "Apigee" },
    { id: "aws-api-gateway", label: "AWS API Gateway" },
    { id: "mulesoft", label: "MuleSoft" },
    { id: "wso2", label: "WSO2 API Manager" },
    { id: "kaltura", label: "Kaltura" },
    { id: "tyk", label: "Tyk" },
    { id: "krakend", label: "KrakenD" }
  ]